import gsap from "gsap";

function initIconic() {
  window.locoScroll.on("scroll", (args) => {
    // console.log('loco')
    if (typeof args.currentElements["iconic"] === "object") {
      // console.log(args.currentElements['iconic'].progress,'---OF ICONIC');

      // @todo calculate these values for linear speed,
      // take height of image block
      //
      if (window.isMobile) {
        gsap.set(".iconic__images", {
          y: -150 + args.currentElements["iconic"].progress * 350 + "%",
        });
      } else {
        gsap.set(".iconic__images", {
          y: -100 + args.currentElements["iconic"].progress * 200 + "%",
        });
      }
    }
  });
}

if (document.querySelector(".iconic")) {
  initIconic();
}
